import { BaseModel } from './base.model'
import { DeviceModel } from './device.model'

export class DeviceVendor extends BaseModel {
  id: number
  name: DeviceVendorName
  models: DeviceModel[]
}

export enum DeviceVendorName {
  Teltonika = 'Teltonika',
  DigitalMatter = 'Digital Matter',
  Ulbotech = 'Ulbotech',
  Topflytech = 'Topflytech',
}
